/**
 * Normalizes a country display name for comparison only. RM2 country codes are
 * never derived from the name; this exists purely to tolerate punctuation and
 * spacing differences between MS Sales customer search results and the
 * commercial metadata catalogue (for example "Korea, Republic of" vs
 * "Korea Republic of").
 */
const normalizeCountryName = (value) => value
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");
/**
 * Resolves the commercial-metadata country entry for a display name or id.
 * The caller must use the returned alpha codes verbatim: RM2 uses a handful of
 * non-ISO codes (Kosovo is XKS), so deriving alpha3 from the name or from
 * alpha2 produces values RM2 rejects.
 */
export const findCountryMetadata = (countries, countryName, countryId) => {
    const trimmedCountryId = (countryId || "").trim();
    if (trimmedCountryId && (countries === null || countries === void 0 ? void 0 : countries.length)) {
        const matchedById = countries.find((country) => (country.id || "").toLowerCase() === trimmedCountryId.toLowerCase());
        if (matchedById) {
            return matchedById;
        }
    }
    const trimmedCountry = countryName.trim();
    if (!trimmedCountry || !(countries === null || countries === void 0 ? void 0 : countries.length)) {
        return undefined;
    }
    const exactMatch = countries.find((country) => (country.name || "").toLowerCase() === trimmedCountry.toLowerCase());
    if (exactMatch) {
        return exactMatch;
    }
    const normalizedCountry = normalizeCountryName(trimmedCountry);
    if (!normalizedCountry) {
        return undefined;
    }
    return countries.find((country) => normalizeCountryName(country.name || "") === normalizedCountry);
};
/**
 * True when a country has been chosen but no Alpha-3 code has been resolved for
 * it. UEM rejects such a submission with a 400 before it reaches RM2, so this
 * is a blocking condition rather than a cosmetic gap.
 */
export const isCountryCodeMissing = (countryName, countryAlpha3) => (countryName || "").trim() !== "" && (countryAlpha3 || "").trim() === "";
